/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-24 09:27:10
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-24 14:59:48
 * @FilePath: \hlweb2.0\src\i18n.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import zh from "./language/zh";
import en from "./language/en";

i18n
  .use(LanguageDetector) // 从 localStorage / 浏览器语言检测
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    fallbackLng: "zh", // 默认语言
    interpolation: { escapeValue: false },
  });

export default i18n;